enum DiscussionTopic {
    NauseaOrVomiting,
    RoutinePrenatalCare,
    Safety,
    HealthyWeightGain,
    PhysicalActivity,
    SeatbeltUse,
    SexualActivity,
    BreastFeeding,
    Travel,
    QualityInformationSources,
    VaginalBirthAfterCesareanDeliveryCounseling,
    PrenatalClasses,
    PretermLabour,
    PreLabourRuptureOfMembranes,
    Bleeding,
    SecondTrimesterFetalMovement,
    SecondTrimesterMentalHealth,
    VaginalBirthAfterCesareanDeliveryConsent,
    ThirdTrimesterFetalMovement,
    BirthPlan,
    TypeOfBirthPotentialInterventions,
    AdmissionTiming,
    BreastfeedingAndSupport,
    NewBornCareOrScreeningTests,
    DischargePlanningOrCarSeatSafety,
    WorkPlanOrMaternityLeave,
    ThirdTrimesterMentalHealth,
    Contraception,
    PostpartumCare
}

export { DiscussionTopic };
